import React from 'react';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import PropTypes from 'prop-types';
import TextInput from '../../../core/form/TextInput';
import DateInput from '../../../core/form/DateInput';
import Select from '../../../core/form/Select';
import Button from '../../../core/form/Button';
import { Checkbox } from 'antd';
import get from 'lodash/get';
import PermissionValidator from '../../../core/layout/PermissionValidator';
import { Roles } from '../../../core/util';

const BillListFilter = (props) => (
  <>
    <Row>
      <Column xl={2} xxl={2}>
        <TextInput
          label="Bill ID"
          value={get(props.values, 'billId', null)}
          onChange={(value) => props.onChange('billId', value)}
        />
      </Column>
      <PermissionValidator allowedFor={['ADMIN', 'SUPPORT']}>
        <Column xl={4} xxl={2}>
          <TextInput
            label="Document Number"
            value={get(props.values, 'documentNumber', null)}
            onChange={(value) => props.onChange('documentNumber', value)}
          />
        </Column>
        <Column xl={5} xxl={4}>
          <TextInput
            label="Social Reason"
            value={get(props.values, 'socialReason', null)}
            onChange={(value) => props.onChange('socialReason', value)}
          />
        </Column>
      </PermissionValidator>
      <Column xl={3} xxl={2}>
        <DateInput
          label="Created Start"
          value={get(props.values, 'createdStart', null)}
          onChange={(value) => props.onChange('createdStart', value)}
        />
      </Column>
      <Column xl={3} xxl={2}>
        <DateInput
          label="Created End"
          value={get(props.values, 'createdEnd', null)}
          onChange={(value) => props.onChange('createdEnd', value)}
        />
      </Column>
      <Column xl={3} xxl={2}>
        <DateInput
          label="Due Start"
          value={get(props.values, 'dueStart', null)}
          onChange={(value) => props.onChange('dueStart', value)}
        />
      </Column>
      <Column xl={3} xxl={2}>
        <DateInput
          label="Due End"
          value={get(props.values, 'dueEnd', null)}
          onChange={(value) => props.onChange('dueEnd', value)}
        />
      </Column>
      <Column xl={3} xxl={2}>
        <Select
          label="Status"
          value={get(props.values, 'status', null)}
          onChange={(value) => props.onChange('status', value)}
          options={
            [Roles.COMPANY_MANAGER, Roles.DISTRIBUTOR_MANAGER].includes(localStorage.role)
              ? [
                  {
                    label: 'Sent to client',
                    value: 'SENT_TO_CLIENT',
                  },
                  {
                    label: 'Paid',
                    value: 'PAID',
                  },
                ]
              : [
                  {
                    label: 'Open',
                    value: 'OPEN',
                  },
                  {
                    label: 'Sent to client',
                    value: 'SENT_TO_CLIENT',
                  },
                  {
                    label: 'Paid',
                    value: 'PAID',
                  },
                  {
                    label: 'Processing Payment',
                    value: 'PROCESSING_PAYMENT',
                  },
                  {
                    label: 'No charge',
                    value: 'NO_CHARGE',
                  },
                  {
                    label: 'Review',
                    value: 'REVIEW',
                  },
                  {
                    label: 'Canceled',
                    value: 'CANCELED',
                  },
                ]
          }
        />
      </Column>
      <Column xl={3} xxl={2} style={{ textAlign: 'center' }}>
        <Checkbox
          style={{ marginTop: 47 }}
          value={get(props.values, 'overduePayments', null)}
          onChange={(event) => props.onChange('overduePayments', event.target.checked)}
        >
          Overdue Payments
        </Checkbox>
      </Column>
      <Column xl={2} xxl={2}>
        <div style={{ height: 44 }} />
        <Button label="Search" icon="search" onClick={props.onSearch} disabled={props.fetching} />
      </Column>
      <Column xl={1} xxl={2}>
        <div style={{ height: 44 }} />
        <Button
          label="Export"
          icon="download"
          type="primary"
          onClick={props.onBillReportDownload}
          disabled={props.fetching}
          loading={props.fetching}
        />
      </Column>
    </Row>
  </>
);

BillListFilter.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onBillReportDownload: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired,
};

BillListFilter.defaultProps = {
  values: {},
};

export default BillListFilter;
